import React, { useEffect, useState } from 'react';
import axios from 'axios';

const RiskGenerator = ({ selectedTopic, onGetTask }) => {
  const [risk, setRisk] = useState('');
  const [riskTitle, setRiskTitle] = useState('');
  const [riskDescription, setRiskDescription] = useState('');
  const [waitingResponse, setWaitingResponse] = useState(false);
  const [riskList, setRiskList] = useState([]);
  const [lang, setLang] = useState('en');

  // Function to call OpenAI API and generate a risk
  const generateRisk = async () => {
	if(waitingResponse){
		return;
	}
	setWaitingResponse(true);
	//console.log('Generating risk...');
	if (!selectedTopic) {
	  alert('No topic selected. Please select a topic first.');
	  return;
	}
  
	//const apiURL = '/cia_2023/php-gpt/';
	const apiURL = '/php-gpt/';
	
	// This is an example message, tailor it to fit the conversation flow you desire
	const data = {
	  model: "gpt-3.5-turbo",
	  //model: "gpt-3.5-turbo",
	  messages: [
		// {
		// 	"role": "system",
		// 	"content": "Knowledgeable and crisp, but with a sense of humour that will attract engagement, rather than annoy\nUse lots of emojis.\nSimple language that a high school student can understand\nKeep GPT responses to a low word count — no big paragraphs, where possible. Limit this to two sentences."
		// },
		// { "role": "user", "content": `Identify one risk associated with the topic ${selectedTopic} from an actuary's perspective? Return the response as json, giving it a title and then the full risk as a description. Formatted like {"title":"",description:""}.` }
		{
			"role": "system",
			"content": `Generate a single risk related to “${selectedTopic}” that would be relevant to an actuary - in a way that a 15 year old highschool student would understand. Do not mention “actuary” in the response. Give it a title and then write a conclusion sentence that describes how this risk can affect many people companies and governments. Formatted like {"title":"",description:""}. Do not exceed 50 words and speak professionally, but with a respectful approachability and likability. `
		}
	  ],
	  max_tokens: 128,
	};
	if(window.lang === 'fr'){
		data.messages.push({ "role": "system", "content": "Use Canadian French language only."});
	}
	if(riskList.length > 0){
		data.messages.push({ "role": "user", "content": "Ensure the risk is different than the previous ones: "+riskList.join(", ") });
	}	
	try {
	  const response = await axios.post(apiURL, data);
		//console.log(response);
	  const messages = response.data.choices;
	  // Assuming the last message is the AI's response
	  const aiMessage = messages[messages.length - 1].message.content;
	  //if aiMessage is json, then parse it and set the risk
	  if(aiMessage.startsWith("{")){
		  const json = JSON.parse(aiMessage);
		  setRiskTitle(json.title);
		  setRiskDescription(json.description);
		  setRisk(json.description);
		  setWaitingResponse(false);
		  setRiskList([...riskList, json.title]);
	  }
	  else{
	  	setRisk(aiMessage);
	  	setWaitingResponse(false);
	  }
	} catch (error) {
	  console.error('Error generating risk:', error);
	  setWaitingResponse(false);
	  //alert('Failed to generate risk. Please check the console for more information.');
	  //wait 2 seconds and try again
	  setTimeout(generateRisk, 2000);
	}
  };

  useEffect(() => {
	generateRisk();
	if(window.lang === 'fr'){
		setLang('fr');
	}
  }, []);

  const getNewRisk = () => {
		setRisk('');
		generateRisk();
  }

  return (
    <div className="appMiddleContainer">
      <h3>{selectedTopic}</h3>
		<div className="risk-block my-4">
			{risk && risk !== '' ? (
				<>
					<h5>{lang == 'fr' ? "RISQUE" : "RISK"}</h5>
					<h4>{riskTitle}</h4>
					<p>{riskDescription}</p>
				</>
			) : (
				<div class="snippet" data-title="dot-falling">
					<div class="stage">
					<div class="dot-falling"></div>
					</div>
				</div>
			)}
		</div>
		<div className="d-flex flex-column flex-lg-row justify-content-center gap-4">
			<button className="btn btn-green" onClick={() => onGetTask(risk)}>{lang == 'fr' ? "Clavarde avec l’IA":"Chat with AI"}</button>
			<button className="btn btn-outline-teal" onClick={() => getNewRisk()}>{lang == 'fr' ? "Montrez-moi un autre risque":"Show me another risk"}</button>
		</div>
    </div>
  );
};

export default RiskGenerator;